import React from 'react';
import {TableRow} from 'material-ui/Table';


export default (props) => {

    const {rowData, onMyRowClick, ...restProps} = props;
    let onRowClick = (e) => {
        if (props.onMyRowClick && typeof e.target.value === 'undefined')
        {
            e.stopPropagation();
            props.onMyRowClick();
        }
    }
    var cn = " ClickableRow " + props.className;
    return (
        <TableRow 
        {...restProps}
        className={ cn}
        onMouseDown={onRowClick}>
        {props.children}
        </TableRow>
    )
};



// WEBPACK FOOTER //
// ./src/components/Grid/ClickableRow.jsx